import * as React from "react";
const SvgFiRrNoFee = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-no-fee_svg__a)">
      <path
        fill="#062147"
        d="m12.544 8.026-.777.777 1.271 1.271.777-.777a.798.798 0 1 1 1.129 1.129l-.777.777 1.553 1.553a.798.798 0 1 1-1.129 1.129l-4.518-4.518a.8.8 0 0 1 0-1.129l1.341-1.341a.798.798 0 1 1 1.13 1.129m8.4-.494a.8.8 0 0 0 1.129 0l1.341-1.341a.798.798 0 1 0-1.129-1.129l-.777.777-.989-.988.777-.777a.798.798 0 1 0-1.129-1.129l-.777.777-1.271-1.271.777-.777A.798.798 0 1 0 17.767.545l-1.341 1.341a.8.8 0 0 0 0 1.129zM2.041 12.91Q2.001 12.46 2 12C2 6.486 6.486 2 12 2q.46 0 .91.041a1 1 0 0 0 .18-1.992A12 12 0 0 0 12 0C5.383 0 0 5.383 0 12q0 .551.049 1.09a1 1 0 0 0 .995.91c.55-.05 1.046-.54.997-1.09M13.25 6.191l4.518 4.518a.8.8 0 0 0 1.129 0l1.341-1.341a.798.798 0 1 0-1.129-1.129l-.777.777-.989-.989.777-.777a.798.798 0 1 0-1.129-1.129l-.777.777-1.271-1.271.777-.777a.798.798 0 1 0-1.129-1.129L13.25 5.062a.8.8 0 0 0 0 1.129m10.702 4.721a1 1 0 1 0-1.992.176q.04.45.041.912c0 5.514-4.486 10-10 10q-.46-.001-.912-.041a.99.99 0 0 0-1.084.907 1 1 0 0 0 .908 1.085q.538.048 1.088.049c6.617 0 12-5.383 12-12q0-.55-.049-1.088M11.627 17.98a2.5 2.5 0 0 1-3.529 0L5.98 15.862a2.5 2.5 0 0 1 0-3.529 2.5 2.5 0 0 1 3.529 0l2.118 2.118a2.5 2.5 0 0 1 0 3.529m-1.129-2.4L8.38 13.462a.9.9 0 0 0-1.271 1.271l2.118 2.118a.9.9 0 0 0 1.271 0 .9.9 0 0 0 0-1.271m-6.424-.212a.798.798 0 1 0-1.129 1.129L5.248 18.8l-3.551-1.371a.968.968 0 0 0-1.033 1.587l4.398 4.398a.798.798 0 1 0 1.129-1.129l-2.297-2.297 3.545 1.365a.968.968 0 0 0 1.032-1.588z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-no-fee_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrNoFee;
